<template lang="pug">
section
  .handler
    s-editor-image-upload(
      :src='block.value.url',
      :ratio='null',
      label='Нажмите для загрузки картинки',
      @upload-success='update',
      @click-image='openDialog'
    )
    .edit(v-if='block.value.url')
      v-btn(@click='openDialog', icon, depressed, color='white')
        v-icon edit
  v-dialog(v-model='editDialog', width='280')
    v-card
      v-form(@submit='closeDialog')
        .pa-3
          v-text-field(
            label='Название',
            v-model='block.value.name',
            @input='$emit("update", block)'
          )
</template>

<script>
import BaseBlock from './BaseBlock'
import PropTypes from '@znck/prop-types'

export default {
  extends: BaseBlock,

  props: {
    block: PropTypes.shape({
      type: PropTypes.string.isRequired,
      value: PropTypes.shape({
        url: PropTypes.string,
        hash: PropTypes.string,
        name: PropTypes.string,
      }),
    }),
  },

  data: () => ({
    editDialog: false,
  }),

  methods: {
    update({ url, hash }) {
      this.block.value.url = url
      this.block.value.hash = hash
      this.$emit('update', this.block)
    },

    closeDialog(ev) {
      ev.preventDefault()
      this.editDialog = false
    },

    openDialog() {
      this.editDialog = true
    },
  },
}
</script>

<style scoped>
.handler {
  position: relative;
}
.edit {
  bottom: 24px;
  right: 12px;
  position: absolute;
}
</style>
